import React from 'react';

import loadable from '@loadable/component';
import { TabContentProgress } from '../TabPanel';

const AsyncRuleFormulaEditor = loadable(
    () => import(/* webpackPrefetch: true */ './RuleFormulaEditor'
    ), {
        fallback: (
            <TabContentProgress>
                Loading Editor...
            </TabContentProgress>
        )
    });

const RuleFormulaFieldset = (props) => (
    <AsyncRuleFormulaEditor {...props} />
);

export default RuleFormulaFieldset;
